import { render, staticRenderFns } from "./PlaceFilter.vue?vue&type=template&id=2509e43e&"
import script from "./PlaceFilter.vue?vue&type=script&lang=js&"
export * from "./PlaceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports